<template>
  <k-tree hoverable
    :activatable="activatable" 
    :selectable="selectable"
    :selection-type="selectionType"
    v-model="selected"
    :active.sync="active" 
    :open="open_lists" 
    :search="search"
    :filter="list_filter"
    :items="tree"
    :removable="removable"
    @remove="$emit('remove', $event)"
    v-if="tree.length > 0"
  >
    <template slot="prepend" slot-scope="{ item }">
      <slot name="prepend" :item="item"></slot>
    </template>
    <template slot="label" slot-scope="{ item }">
      {{ item.id }}
      {{ item.name }}
    </template>
    <template slot="append" slot-scope="{ item }">
      <slot name="append" :item="item"></slot>
    </template>
  </k-tree>
</template>

<script>
import ContentModel from '@/models/content.js'
import Vue from 'vue'

export default {
  props:{
    id: String,
    search: { type: String, default: '' },
    selectable: { type: Boolean, default: false },
    removable: { type: Boolean, default: false },
    selectionType: { type: String, default: 'leaf'},
    activatable: { type: Boolean, default: false},
    previewItems: { type: Array, default() { return [] }},
    value: { type: Array, default() { return [] }},
    openAll: { type: Boolean, default: false }
  },
  components: {
  },
  data () {
    return {
      filtered_lists: {},
      selected: this.value
    }
  },
  watch: {
    value(newVal) {
      this.selected = newVal;
    },
    selected() {
      this.$emit('input', this.selected)
    }
  },
  computed: {
    active: {
      get () {
        return (typeof(this.id) != "undefined") ? ContentModel.get_path(parseInt(this.id), {include_list: true}) : [];
      },
      set (val) {
        if(val.length > 0 && this.id != val[0]) {
          this.open_list(val[0]);
        };
      }
    },
    open_lists () {
      if(this.openAll) {
        return Object.keys(this.cms_lists).map(Number);
      }
      let open = new Set();
      if(this.search.trim().length > 1 || (!isNaN(this.search)) && this.search.trim() != '') {
        for(const list_id of Object.keys(this.filtered_lists)) {
          let path = new Set(ContentModel.get_path(list_id));
          open = open.union(path);
        }
      };
      for(const id of this.selected) {
        let path = new Set(ContentModel.get_path(id));
        open = open.union(path);
      }
      open = Array.from(open);
      return open.concat(this.active);
    },
    search_path () {
      let path = this.search.toLowerCase().split("/").reverse();
      if(path[0] == "") path.shift();
      return path;
    },
    cms_lists () {
    if(this.$store.getters.is_privilege(["developer"])) {
      return this.$store.state.cms_lists;
    }
    return this.$store.state.cms_lists_no_sys;
    },
    list_filter () {
      return (item, search) => {
        if((search.trim().length < 2) && isNaN(search)) {
          this.filtered_lists = {};
          return true;
        };
        let target = '';
        target = ` ${item.id} ${item.name.toLowerCase()} `;
        let target_item = item;
        for(const search_item of this.search_path) {
          if(target.includes(search_item)) {
            let parent = this.cms_lists[target_item.meta.parent_list_id];
            if(parent) {
              target = ` ${parent.id} ${parent.name.toLowerCase()} `;
              target_item = parent;
            };
          } else {
            Vue.delete(this.filtered_lists, item.id);
            return false;
          };
        };
        Vue.set(this.filtered_lists, item.id);
        return true;
      };
    },
    tree () {
      let lists = _.cloneDeep(this.cms_lists);
      if(this.previewItems.length > 0) {
        lists = _.pick(lists, this.previewItems)
      }

      let tree = [];
      for (const [id, list] of Object.entries(lists)) {
        if(list.meta.parent_list_id != undefined) {
          let parent = lists[list.meta.parent_list_id]
          if(parent) {
            if(!parent.children) parent.children = [];
            parent.children.push(lists[id]);
          } else {
            tree.push(lists[id]);
          };
        }
        else tree.push(lists[id]);
      };
      return tree;
    }
  },
  mounted () {
    this.$store.dispatch("get_profile");
  },
  methods: {
    open_list (id) {
      if(this.$router.currentRoute.params.id != id) {
        this.$router.push("/content/list/"+id);
      }
    }
  }
}
</script>

<style>
</style>